import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { ActionType } from "./actions.js";
import { addRelationshipAction, changeRelationshipColumnsAction, changeRelationshipOnDeleteAction, changeRelationshipOnUpdateAction, changeRelationshipTypeAction, namesOtherTables, removeRelationshipAction } from "./atom.actions.js";
import { pick } from "es-toolkit";
//#region src/engine/modules/relationship/history.ts
var addRelationship = (undoActions, { payload: { id } }) => {
	undoActions.push(removeRelationshipAction({ id }));
};
var removeRelationship = (undoActions, { payload: { id } }, { collections }) => {
	const relationship = query(collections).collection("relationshipEntities").selectById(id);
	if (!relationship) return;
	undoActions.push(addRelationshipAction({
		id: relationship.id,
		relationshipType: relationship.relationshipType,
		onDelete: relationship.onDelete,
		onUpdate: relationship.onUpdate,
		start: pick(relationship.start, ["tableId", "columnIds"]),
		end: pick(relationship.end, ["tableId", "columnIds"])
	}));
};
var changeRelationshipType = (undoActions, { payload: { id } }, { collections }) => {
	const relationship = query(collections).collection("relationshipEntities").selectById(id);
	if (!relationship) return;
	undoActions.push(changeRelationshipTypeAction({
		id,
		value: relationship.relationshipType
	}));
};
var changeRelationshipOnDelete = (undoActions, { payload: { id } }, { collections }) => {
	const relationship = query(collections).collection("relationshipEntities").selectById(id);
	if (!relationship) return;
	undoActions.push(changeRelationshipOnDeleteAction({
		id,
		value: relationship.onDelete
	}));
};
var changeRelationshipOnUpdate = (undoActions, { payload: { id } }, { collections }) => {
	const relationship = query(collections).collection("relationshipEntities").selectById(id);
	if (!relationship) return;
	undoActions.push(changeRelationshipOnUpdateAction({
		id,
		value: relationship.onUpdate
	}));
};
var changeRelationshipColumns = (undoActions, { payload: { id, start, end } }, { collections }) => {
	const relationship = query(collections).collection("relationshipEntities").selectById(id);
	if (!relationship || namesOtherTables(relationship, {
		start,
		end
	})) return;
	undoActions.push(changeRelationshipColumnsAction({
		id,
		start: {
			tableId: relationship.start.tableId,
			columnIds: [...relationship.start.columnIds]
		},
		end: {
			tableId: relationship.end.tableId,
			columnIds: [...relationship.end.columnIds]
		}
	}));
};
var relationshipPushUndoHistoryMap = {
	[ActionType.addRelationship]: addRelationship,
	[ActionType.removeRelationship]: removeRelationship,
	[ActionType.changeRelationshipType]: changeRelationshipType,
	[ActionType.changeRelationshipOnDelete]: changeRelationshipOnDelete,
	[ActionType.changeRelationshipOnUpdate]: changeRelationshipOnUpdate,
	[ActionType.changeRelationshipColumns]: changeRelationshipColumns
};
//#endregion
export { relationshipPushUndoHistoryMap };
